import React from 'react'
import styled from 'styled-components'
import { youTubeGetID } from '../../utils/youTubeGetId'

interface VideoPlayerProps {
  videoUrl: string
}

const VideoIFrame = styled.iframe`
  width: 60%;
  height: 100%;
  margin: 0 auto;
`

const YOUTUBE_EMBED_PREAMBLE = 'https://www.youtube.com/embed/'

export const VideoPlayer: React.FunctionComponent<VideoPlayerProps> = ({ videoUrl }) => {
  return (
    <VideoIFrame
      src={`${YOUTUBE_EMBED_PREAMBLE + youTubeGetID(videoUrl)}`}
      frameBorder="0"
      allow="autoplay; encrypted-media"
      title="video"
    />
  )
}
